/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type ProductIconsSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProductIconsSettingsQuery = { __typename?: 'Query', productIconsSettingsCollection?: { __typename?: 'ProductIconsSettingsCollection', items: Array<{ __typename?: 'ProductIconsSettings', title?: string | null, productTypeIcons?: { __typename?: 'ProductIconsSettingsProductTypeIconsCollection', items: Array<{ __typename?: 'ProductTypeIcons', productType?: string | null, icons?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', url?: string | null, title?: string | null, height?: number | null, width?: number | null } | null> } | null } | null> } | null } | null> } | null };

export declare const productIconsSettings: import("graphql").DocumentNode;

export const ProductIconsSettingsDocument = /*#__PURE__*/ `
    query productIconsSettings {
  productIconsSettingsCollection(
    limit: 1
    where: {handle: "product-icons-settings"}
  ) {
    items {
      title
      productTypeIcons: productTypeIconsCollection(where: {sys: {id_exists: true}}) {
        items {
          productType
          icons: iconsCollection {
            items {
              url
              title
              height
              width
            }
          }
        }
      }
    }
  }
}
    `;
export const useProductIconsSettingsQuery = <
      TData = ProductIconsSettingsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: ProductIconsSettingsQueryVariables,
      options?: UseQueryOptions<ProductIconsSettingsQuery, TError, TData>
    ) =>
    useQuery<ProductIconsSettingsQuery, TError, TData>(
      variables === undefined ? ['productIconsSettings'] : ['productIconsSettings', variables],
      fetcher<ProductIconsSettingsQuery, ProductIconsSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ProductIconsSettingsDocument, variables, options),
      options
    );

useProductIconsSettingsQuery.getKey = (variables?: ProductIconsSettingsQueryVariables) => variables === undefined ? ['productIconsSettings'] : ['productIconsSettings', variables];
;

useProductIconsSettingsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: ProductIconsSettingsQueryVariables, options?: RequestInit['headers']) => fetcher<ProductIconsSettingsQuery, ProductIconsSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ProductIconsSettingsDocument, variables, options);